import { Component, OnInit, ViewChild, Input } from '@angular/core'; 
import { Router, ActivatedRoute } from '@angular/router';
import { MatSort } from '@angular/material/sort';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table'
import { CreativeTemplateService } from '../../shared/services/creativeTemplate.service';
import { CreativeTemplate } from '../../shared/models/creativeTemplate';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmationModalService } from '../../shared/components/modals/confirmation-modal/confirmation-modal.service';
import { CreativeTemplateEditFormComponent } from '../../shared/components/modals/creative-template-edit-modal/creative-template-edit.component';
import { CreativeTemplateAddFormComponent } from '../../shared/components/modals/creative-template-add-modal/creative-template-add.component';
import { FileService } from '../../shared/services/file.service';
import { environment } from '../../../environments/environment';
import FlatfileImporter from "flatfile-csv-importer";
import { AuthorizeService } from 'src/api-authorization/authorize.service';
import { CampaignType } from '../../shared/models/CampaignType';
import { AgeRange } from '../../shared/models/ageRange';
import { AgeRangeService } from '../../shared/services/ageRange.service';
import { CampaignTypeService } from '../../shared/services/campaignType.service';

declare var $: any;

@Component({
  selector: 'app-matrix', 
  templateUrl: './matrix.component.html'
})

export class MatrixComponent implements OnInit {  
  // MatPaginator Inputs
  length = 20;
  pageSize = 10;
  pageSizeOptions: number[] = [10, 25, 100];
  pageEvent: PageEvent;
  dataSource = new MatTableDataSource<CreativeTemplate>();
  displayedColumns: string[] = ['actions', 'id', 'brandName', 'campaignTypeName', 'months', 'ageRangeName', 'gender', 'frontImage', 'frontCTA', 'frontOffer', 'frontLogo', 'backLogo', 'backCTA', 'backBackground', 'backTopLeftCopy', 'backBottomLeftCopy', 'backOfferBlock' ];
  public userName: string;
  public userId: string;
  private importer: FlatfileImporter; // flatfile importer
  public creativeTemplateImportList: CreativeTemplate[];
  public campaignTypeList: CampaignType[];
  public ageRangeList: AgeRange[];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    private creativeTemplateService: CreativeTemplateService,
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private notification: MatSnackBar,
    private confirmationModalService: ConfirmationModalService,
    private fileService: FileService,
    private ageRangeService: AgeRangeService,
    private campaignTypeService: CampaignTypeService,
    private authorizeService: AuthorizeService,
  ) { }
   
  private _id; // private property _item

  // use getter setter to define the property
  get id(): any {
    return this._id;
  }

  @Input()
  set id(val: any) { 
    this._id = val; 
  } 

  // call get locations on load 
  ngOnInit() {

    // get current user
    this.authorizeService.getUser().subscribe(result => {
      this.userName = result.name;
      this.userId = result.sub;
    });

    //

    // bind campaign dropdown
    this.campaignTypeService.getAll().subscribe(cResult => {

      this.ageRangeService.getAll().subscribe(aResult => {
        this.ageRangeList = aResult;
      });
       
      this.campaignTypeList = cResult;


    // call importer initializer
      this.initializeImporter();
    });

    // get matrix records
    this.getRecords(this.id);

   
  }

  // get matrix records
  getRecords(id: number): void {
    if (id > 0) {  
      this.creativeTemplateService.getAll(id).subscribe(result => { 
          this.dataSource.data = result;
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort; 
      }, error => console.error(error));
    }
  }

  // open add form for location
  openAddModal() {
    let modalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
    };

    const modalRef = this.modalService.open(CreativeTemplateAddFormComponent, modalOptions);
    modalRef.componentInstance.title = 'Add an entry';
    modalRef.componentInstance.brandId = this.id;
     
    // modal result
    modalRef.result.then((result) => { 
        this.getRecords(this.id); 
    }).catch(() =>
      console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
    ); 
  } 

  // delete creative template entry
  deleteCreativeTemplate(id: number) {

    this.confirmationModalService.confirm('Confirm', 'Are you sure you want to delete this item?')
      .then((confirmed) => {  
        if (confirmed) {
          this.creativeTemplateService.delete(id).subscribe(() => {
              this.showNotification('The item has been deleted successfully!', 'Okay!');
              this.getRecords(this.id);
            });
          }
        }
      )
      .catch(() =>
        console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
      ); 
  }

  // copy entry
  copyCreativeTemplate(item: CreativeTemplate): void {

    let modalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
    };

    const modalRef = this.modalService.open(CreativeTemplateAddFormComponent, modalOptions);
    modalRef.componentInstance.title = 'Add an entry';
    modalRef.componentInstance.brandId = this.id;
    modalRef.componentInstance.model = item;

    // modal result
    modalRef.result.then((result) => {
      this.getRecords(this.id);
    }).catch(() =>
      console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
    ); 
  }


  // edit location
  editCreativeTemplate(item: CreativeTemplate) {

      this.creativeTemplateService.getById(item.id).subscribe(ct => {
          let template = ct;
          let modalOptions: NgbModalOptions = {
            backdrop: 'static',
            keyboard: false,
          };

          const modalRef = this.modalService.open(CreativeTemplateEditFormComponent, modalOptions);
          modalRef.componentInstance.title = 'Edit Entry';
          modalRef.componentInstance.creativeTemplate = ct;

          // modal result
          modalRef.result.then((result) => {
            if (result) {
              this.getRecords(this.id);
            }
          }).catch(() =>
            console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
          );

      }); 
  }
   
  exportData() { 
    let headerList: Array<string> = [
      "campaignTypeName",
      "brandName",
      "templateId",
      "months",
      "ageRangeName",
      "gender",
      "frontImage",
      "frontCTA",
      "frontOffer",
      "frontLogo",
      "backLogo",
      "backCTA",
      "backBackground",
      "backTopLeftCopy",
      "backOfferBlock",
      "backStoreBlock",
      "backBottomLeftCopy",
      "style" 
    ];
    this.fileService.downloadFile(this.dataSource.data, headerList, "datafile");
  }
    
  // filter locations
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  //reload page
  reloadPage() {
    window.location.reload();
    //this.router.navigate([this.route.url])
  }


  // init flatfile importer
  initializeImporter() {

    //License key available from your app dashboard at flatfile.io
    FlatfileImporter.setVersion(2);

    //this.brandSelectOptions = this.brands.map(b => ({ value: b.name, label: b.name }));
    //this.campaignSelectOptions = this.campaignTypes.map(b => ({ value: b.name, label: b.name }));

    this.importer = new FlatfileImporter(environment.flatFileLicenseKey, {
      fields: this.getFlatfileFields(),
      title: 'Import creative assets (matrix)',
      type: 'CreativeTemplate',
      allowCustom: false,
      //maxRecords: 10000, 
      allowInvalidSubmit: true,
      managed: true, // set to true to allow xls files to be imported.
      disableManualInput: true,
      devMode: (!environment.production),
      styleOverrides: {
        borderRadius: '4px',
        primaryButtonColor: '#289cbf',
        primaryButtonBorderColor: '#1f7a95',
        primaryButtonFontSize: '1.6rem',
        primaryButtonFontColor: '#fff',
        secondaryButtonColor: '#8b99a4',
        secondaryButtonBorderColor: '#8b99a4',
        secondaryButtonFontSize: '1.6rem',
        secondaryButtonFontColor: '#fff',
        linkColor: '#289cbf',
        linkAltColor: '#4a90e2',
        primaryTextColor: '#1D2830',
        secondaryTextColor: '#667d8d',
        errorColor: '#ff4c42',
        successColor: '#60b700',
        warningColor: '#f6A623',
        borderColor: '#e8e8e8',
        fontFamily: 'Gilroy, "Helvetica Neue", Arial, sans-serif'
      }
    });

    // set file user info
    this.importer.setCustomer({
      userId: this.userId,
      name: this.userName
    });
  }


  // build fields configuration for flat file
  getFlatfileFields() {
    let config = [
      //{
      //  label: 'Brand',
      //  key: 'brand',
      //  alternates: ["member", 'brand name', 'company name'],
      //  validators: [
      //      {
      //        validate: "required",
      //        error: "this field is required"
      //      }
      //  ]
      //},
      {
        label: 'Months',
        key: 'months',
        alternates: ['month conversion'],
        validators: [
          {
            validate: "required",
            error: "this field is required"
          }
        ]
      },
      {
        label: 'Gender',
        key: 'gender',
        alternates: ['sex'],
        validators: [
          {
            validate: "required",
            error: "this field is required"
          }
        ]
      },
      {
        label: 'Age Range',
        key: 'ageRange', 
        validators: [
          {
            validate: "required",
            error: "this field is required"
          }
        ]
      },
      {
        label: 'Campaign Type',
        key: 'campaignType',
        alternates: ['campaign'],
        validators: [
          {
            validate: "required",
            error: "this field is required"
          }
        ]      },
      {
        label: 'Front Image',
        key: 'frontImage' 
      },
      {
        label: 'Front CTA',
        key: 'frontCTA'
      },
      {
        label: 'Front Offer',
        key: 'frontOffer',
      },
      {
        label: 'Front Logo',
        key: 'frontLogo'
      },
      {
        label: 'Back Logo',
        key: 'backLogo'
      },
      {
        label: 'Back CTA',
        key: 'backCTA'
      },
      {
        label: 'Back Background',
        key: 'backBackground'
      },
      {
        label: 'Back Top Left Copy',
        key: 'backTopLeftCopy'
      },
      {
        label: 'Back Top Left Copy',
        key: 'backTopLeftCopy'
      },
      {
        label: 'Back Offer Block',
        key: 'backOfferBlock'
      },
      {
        label: 'Back Store Block',
        key: 'backStoreBlock'
      },
      {
        label: 'Back Bottom Left Copy',
        key: 'backBottomLeftCopy'
      },
      {
        label: 'Style',
        key: 'style'
      }
    ];
    return config;
  }

  // import matrix
  async importDataFile() {
    try { 
      let results = await this.importer.requestDataFromUser();

        // map data to object  
        this.creativeTemplateImportList = results.validData.map((x) => ({
            id: 0,
            brandId: +this.id,
            brandName: '',// x.hasOwnProperty('brand') ? x.brand.trim() : '',
            campaignTypeId: 0,
           // campaignTypeId: this.campaignTypeList.filter(item => item.name.toLowerCase == x.campaignType.trim().toLowerCase())..id, //x.hasOwnProperty('campaignTypeId') ? +x.campaignTypeId.trim() : 0,
            campaignTypeName: x.hasOwnProperty('campaignType') ? x.campaignType.trim() : '',
            months: x.hasOwnProperty('months') ? +x.months.trim() : 0,
            //ageRangeId: this.ageRangeList.filter(item => item.range.toLowerCase == x.ageRange.trim().toLowerCase())[0].id,
            ageRangeId: 0,
            ageRangeName: x.hasOwnProperty('ageRange') ? x.ageRange.trim() : 'None',
            gender: x.hasOwnProperty('gender') ? x.gender.trim() : 'F',
            frontImage: x.hasOwnProperty('frontImage') ? x.frontImage.trim() : '',
            frontCTA: x.hasOwnProperty('frontCTA') ? x.frontCTA.trim() : '',
            frontOffer: x.hasOwnProperty('frontOffer') ? x.frontOffer.trim() : '',
            frontLogo: x.hasOwnProperty('frontLogo') ? x.frontLogo.trim() : '',
            backLogo: x.hasOwnProperty('backLogo') ? x.backLogo.trim() : '',
            backCTA: x.hasOwnProperty('backCTA') ? x.backCTA.trim() : '',
            backBackground: x.hasOwnProperty('backBackground') ? x.backBackground.trim() : '',
            backTopLeftCopy: x.hasOwnProperty('backTopLeftCopy') ? x.backTopLeftCopy.trim() : '',
            backOfferBlock: x.hasOwnProperty('backOfferBlock') ? x.backOfferBlock.trim() : '',
            backStoreBlock: x.hasOwnProperty('backStoreBlock') ? x.backStoreBlock.trim() : '',
            backBottomLeftCopy: x.hasOwnProperty('backBottomLeftCopy') ? x.backBottomLeftCopy.trim() : '',
            style: x.hasOwnProperty('style') ? x.style.trim() : ''
        }));

      this.creativeTemplateImportList.forEach(item => {

          let filteredCampaignType = this.campaignTypeList.filter(y => y.name.toLowerCase() === item.campaignTypeName.trim().toLowerCase())[0];
          if (filteredCampaignType) {
            item.campaignTypeId = filteredCampaignType.id;
          } 

          let filteredAgeRange = this.ageRangeList.filter(y => y.range.toLowerCase() === item.ageRangeName.trim().toLowerCase())[0];
          if (filteredAgeRange) {
            item.ageRangeId = filteredAgeRange.id;
          }
          else {
            let filteredAgeRangeFallBack = this.ageRangeList.filter(y => y.range.toLowerCase() === 'none')[0];
            item.ageRangeId = filteredAgeRangeFallBack.id;
          }
      });

      this.importer.displayLoader();

      this.creativeTemplateService.addBulk(+this.id, this.creativeTemplateImportList).subscribe(creativeTemplate => {
        this.getRecords(this.id);
        this.importer.displaySuccess("Your data was successfully imported!");
      });

      //this.showNotification(`The matrix file was imported successfully.`, 'Okay!');
  
        
  } catch(e) {
      console.info(e || "window close");
    }
  }

  resetMatrix() {

    this.confirmationModalService.confirm('Confirm', 'Are you sure you want to delete all records from this brand?')
      .then((confirmed) => {
        if (confirmed) {
          this.creativeTemplateService.deleteAll(this.id).subscribe(() => {
            this.showNotification('The records have been deleted successfully!', 'Okay!');
            this.getRecords(this.id);
          });
        }
      }
      )
      .catch(() =>
        console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
      );
  }

  // show notification popup
  showNotification(msg: string, action: string) {
    this.notification.open(msg, action, { duration: 40000, panelClass: ['snackbar-success'] });
  } 
}

